import React from "react"

import classNames from "classnames"

import { ContentTag } from "scrivito"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { useProductPageContext } from "../context/ProductPageContext"

interface ProductPageTitleProps extends React.HTMLAttributes<HTMLDivElement> {}

function TitleContent({
  children,
  value,
  isLoading,
  className,
  innerRef,
  ...props
}: {
  children: React.ReactNode
  value: string | undefined
  isLoading: boolean | undefined
  innerRef: React.Ref<HTMLDivElement>
} & React.HTMLAttributes<HTMLDivElement>) {
  if (!value && !isLoading) return null

  if (isLoading && !value)
    return (
      <div
        {...props}
        ref={innerRef}
        className={classNames("product-page__title", className)}
      >
        <Skeleton />
      </div>
    )

  return (
    <div
      {...props}
      ref={innerRef}
      className={classNames("product-page__title", className)}
    >
      {children ?? value}
    </div>
  )
}

export const ProductPageTitle = React.memo(
  React.forwardRef<HTMLDivElement, ProductPageTitleProps>(
    ({ className, children, ...props }, ref) => {
      const { productData, productObj } = useProductPageContext()

      const isLoading = productData.productInformation?.isLoading

      if (productObj) {
        return (
          <ContentTag
            {...props}
            ref={ref}
            tag="div"
            content={productObj}
            attribute="kind"
            className={classNames("product-page__title", className)}
          />
        )
      }

      const title = productData.productInformation?.data?.productKind

      return (
        <TitleContent
          {...props}
          innerRef={ref}
          className={className}
          value={title}
          isLoading={isLoading}
        >
          {children}
        </TitleContent>
      )
    }
  )
)
